module.exports = __webpack_public_path__ + "static/logo-sm-550becfbdffc24b88ec67363099812bf.mp4";